import { BaseGameMode } from './BaseGameMode';

export class CoinDashMode extends BaseGameMode {
    
    getModeName(): string {
        return "Coin Dash";
    }

    hasPersistentUpgrades(): boolean {
        return false; // No persistent upgrades in Coin Dash
    }

    hasInterstitialPowerups(): boolean {
        return false; // No level-up screens interrupting the dash
    }

    hasCombos(): boolean {
        return true; // Combos are fine
    }

    getVisibleUIElements(): string[] {
        return ['coins', 'hx', 'score'];
    }
}

